import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import type {EmbeddedEditorCallback} from '@Libraries/embedded-editor';
import {EmbeddedEditorAction, openDesignInEmbeddedEditor} from '@Libraries/embedded-editor';
import {noop} from '@Utils/general.util';
import {CircularProgressLoader} from '@Components/circular-progress-loader';
import {useDesignIdsToPublish} from '@Components/social-media-wizard/social-media-wizard.hooks';
import styles from './template-editor-panel.module.scss';

interface TemplateEditorPanelProps {
  onSave: EmbeddedEditorCallback;
  onClose: VoidFunction;
}

const getFirstTemplateId = (idTemplates: string[]): string => {
  return idTemplates[0];
};

export function TemplateEditorPanel({...props}: TemplateEditorPanelProps): ReactElement | null {
  const idTemplates = useDesignIdsToPublish();
  if (idTemplates.length === 0) {
    return null;
  }

  const idTemplate = getFirstTemplateId(idTemplates);

  useEffect(() => {
    if (idTemplate) {
      openDesignInEmbeddedEditor(
        idTemplate,
        noop,
        (designId): void => {
          props.onSave(designId);
        },
        props.onClose,
        EmbeddedEditorAction.COPY,
        window.i18next.t('pmwjs_publish_next')
      );
    }
  }, []);

  return (
    <div className={styles.progressContainer}>
      <CircularProgressLoader classes={styles.marginAuto} />
    </div>
  );
}
